import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  externalThreatsDeleteButton: {
    alignSelf: 'center',
    marginLeft: theme.spacing(1),
    height: '2rem',
    width: '2rem'
  },
  externalThreatsFormControl: {
    display: 'flex',
    width: '100%'
  },
  externalThreatsInput: {
    flexGrow: 1,
    '& fieldset': {
      borderLeftColor:
        'rgba(var(--mui-palette-common-onBackgroundChannel) / 0.23)',
      borderLeftWidth: '0.031rem'
    },
    '& > .MuiInputBase-root': {
      borderBottomLeftRadius: 0,
      borderTopLeftRadius: 0
    }
  },
  externalThreatsSelect: {
    '& fieldset': {
      borderRightColor:
        'rgba(var(--mui-palette-common-onBackgroundChannel) / 0.23)',
      borderRightWidth: '0.031rem'
    },
    borderBottomRightRadius: 0,
    borderTopRightRadius: 0,
    minWidth: '10rem'
  }
}));

export default useStyles;
